module.exports = __webpack_public_path__ + "static/media/firulete1.062b4804.png";